/*
AAB SLICK USED TO HANDLE SLICK CAROUSAL PART
 */

import * as _jQuery from 'jquery';
import './index-dist.scss';

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * Class used to handle Carousal
 * ------------------------------------------------------------------------
 */
export const AabSlickCarousel = ((jQuery) => {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    enum CONSTANTS {
        ODA_SS_DEBUG_KEY = 'oda-ss-db',
        COMPONENT_NAME = 'aab-slick-carousel',
    }

    /**
     * Selector COnstant
     */
    const Selector = {
        CAROUSEL_CONFIG: 'data-carousel-type',
    };
    /**
     * Configuration Constant
     */
    const configurations = {
        cardSlider: {
            centerMode: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            nextArrow: false,
            prevArrow: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 300,
            variableWidth: true,
        },
        cardSliderNoCenterMode: {
            dots: true,
            infinite: false,
            mobileFirst: true,
            nextArrow: false,
            prevArrow: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 300,
            variableWidth: true,
        },
        oneCardSlider: {
            centerMode: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            nextArrow: false,
            prevArrow: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 300,
            variableWidth: false, // on mobile, display actually one card
        },
        threeCardComparisonSlider: {
            appendDots: '.comparison-container',
            arrows: false,
            centerMode: true,
            dots: true,
            infinite: false,
            initialSlide: 1,
            mobileFirst: true,
            nextArrow: false,
            prevArrow: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        draggable: false,
                        initialSlide: 1,
                        slidesToScroll: 3,
                        slidesToShow: 1,
                        swipe: false,
                        touchMove: false,
                    },
                },
            ],
            variableWidth: true,
        },
        twoCardComparisonSlider: {
            appendDots: '.comparison-container',
            centerMode: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            nextArrow: false,
            prevArrow: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: false,
                        dots: false,
                        draggable: false,
                        slidesToScroll: 2,
                        slidesToShow: 2,
                        swipe: false,
                        touchMove: false,
                    },
                },
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        dots: false,
                        draggable: false,
                        slidesToScroll: 2,
                        slidesToShow: 2,
                        swipe: false,
                        touchMove: false,
                    },
                },
            ],
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 300,
            variableWidth: true,
        },
    };

    /**
     * AabSlickCarouselClass Class Used for
     * handling carousal based on configuration
     */
    class AabSlickCarouselClass {
        public carouselSelector;
        private onWindowResize;
        private odaDb: boolean;
        private odaDbMessages: string[];

        /**
         * Constructs the component
         */
        constructor(carouselSelector: string) {
            this.odaDb = sessionStorage.getItem(CONSTANTS.ODA_SS_DEBUG_KEY) === 'true';
            this.odaDbMessages = [];
            // Clear session storage
            if (sessionStorage.getItem(CONSTANTS.COMPONENT_NAME)) {
                sessionStorage.removeItem(CONSTANTS.COMPONENT_NAME);
            }
            this.carouselSelector = carouselSelector;
            this.odaDebugLogMessage('aab-slick-carousel -  constructed');
        }

        /**
         * Object Initializer
         * Set properties after the object has been constructed,
         * but before it can be used by anything else
         */
        public init() {
            const _this = this;
            _this.odaDebugLogMessage('aab-slick-carousel init called');
            if (_this.carouselSelector) {
                Array.prototype.forEach.call(document.querySelectorAll(_this.carouselSelector), (element) => {
                    const carouselConfigurationType = element.getAttribute(Selector.CAROUSEL_CONFIG);
                    if (carouselConfigurationType) {
                        const carousel = jQuery(element);
                        // Currently only one configuration is supported and applied to all aab-slick-carousel instances
                        _this.applySlickCarousel(carousel, configurations[carouselConfigurationType]);
                        jQuery(carousel).on('swipe', (event, slick, direction) => {
                            _this.emitEvent('carouselSwipe');
                        });
						jQuery(carousel).on('click', (event, slick, direction) => {
                            _this.emitEvent('slickDotSwipe');
                        });
                        _this.odaDebugLogMessage('aab-slick-carousel initialized');
                    } else {
                        _this.odaDebugLogMessage('aab-slick-carousel Failed to initialize: element with attribute \'data-carousel-type\' not found.');
                    }
                });
                // Call function when resize
                window.addEventListener('orientationchange', (e) => {
                    _this.onWindowResize(e, _this);
                });
                /**
                 * On window resize actions
                 */
                _this.onWindowResize = (e) => {
                    _this.reInitSlickCarousel();
                };
            } else {
                // Show an message that aab-carousel was not found, but this is not per definition an error
                _this.odaDebugLogMessage('aab-slick-carousel or its configuration not found');
            }
            _this.odaDebugGetMessages();
        }

        /**
         * emitEvent Function used to
         * emit Event
         * when user slide
         * @param eventType Event type
         */
        public emitEvent(eventType) {
            const carouselSwipe = document.createEvent('Event');
            carouselSwipe.initEvent(eventType, true, true);
            document.dispatchEvent(carouselSwipe);
        }

        /**
         * function to apply slick carousal
         * @param carousel carousal object
         * @param config Config object properties
         */
        public applySlickCarousel(carousel, config) {
            return carousel.not('.slick-initialized').slick(config);
        }

        /**
         * Function to reapply carousal
         * @param carousel carousal object
         * @param config Config object properties
         */
        public reApplySlickCarousel(carousel, config) {
            this.unSlickCarousel(carousel, config, () => {
                const _carousel = carousel;
                const _config = config;
                _carousel.not('.slick-initialized').slick(_config);
            });
        }

        /**
         * function unSlickCarousel to untag carousal
         * @param carousel Carousal Object
         * @param config Config Object Properties
         * @param reslick Carousal Object
         */
        public unSlickCarousel(carousel, config, reslick) {
            const _carousel = carousel;
            _carousel.slick('unslick');
            reslick();
        }

        /**
         * reInitSlickCarousel function to
         * reinitilaize carousal
         */
        public reInitSlickCarousel() {
            const _this = this;
            if (_this.carouselSelector) {
                Array.prototype.forEach.call(document.querySelectorAll(_this.carouselSelector), (element) => {
                    const carouselConfigurationType = element.getAttribute(Selector.CAROUSEL_CONFIG);
                    if (carouselConfigurationType) {
                        const carousel = jQuery(element);
                        _this.reApplySlickCarousel(carousel, configurations[carouselConfigurationType]);
                    }
                });
            }
        }
        /***
         * Add debug message to
         * Session Storage object
         * @param message
         */
        private odaDebugLogMessage(message: string) {
            const _this = this;
            if (_this.odaDb && message) {
                _this.odaDbMessages.push(message);
            }
        }
        /***
         * Register debug messages
         * in a temporary array
         */
        private odaDebugGetMessages() {
            const _this = this;
            if (_this.odaDb && _this.odaDbMessages && _this.odaDbMessages.length > 0) {
                sessionStorage.setItem(CONSTANTS.COMPONENT_NAME, _this.odaDbMessages.join('|||'));
            }
        }
    }
    return AabSlickCarouselClass;

})(_jQuery);

export default AabSlickCarousel;

/**
 * function to initialize
 * Slick Carousel
 */
function initializeSlickCarousel() {
    const aabSlickCarousel = new AabSlickCarousel('.carousel');
    aabSlickCarousel.init();
    Array.prototype.forEach.call(document.querySelectorAll('.small-comparison .checkmark li.disabled'), (element) => {
        element.setAttribute('aria-hidden', 'true');
    });
}


if (document.readyState === 'loading') {  // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', initializeSlickCarousel);
} else {  // `DOMContentLoaded` has already fired
    initializeSlickCarousel();
}

document.addEventListener('slickCarousal',initializeSlickCarousel);
